import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { ReportSchedule } from 'apis/merchant-gateway/insights';
import { Typography } from 'common/typography';
import { telemetryBusinessInsightsV2ReportBuilderChooseCadence } from 'modules/insights-v2/telemetry';

import CustomSelect from '../core/CustomSelect';
import ReportFormItem from '../core/ReportFormItem';
import { InsightReportForm } from '../types';

const StyledCheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  padding-block-start: 4px;
  margin-block-end: 8px;
`;

export const reportScheduleOptions: { [key in ReportSchedule]: string } = {
  [ReportSchedule.MONTHLY]: 'insights.reports.frequency.monthly',
  [ReportSchedule.WEEKLY]: 'insights.reports.frequency.weekly',
  [ReportSchedule.DAILY]: 'insights.reports.frequency.daily',
};

export const ReportScheduleFormItem = ({ supportedSchedules }: { supportedSchedules: ReportSchedule[] }) => {
  const { formatMessage } = useIntl();
  const insightsReportForm = useForm<InsightReportForm>();
  const insightsReportFormState = insightsReportForm.getState();
  return (
    <ReportFormItem
      title={<FormattedMessage id="insights.reports.frequency.question" />}
      value={
        <>
          <StyledCheckboxGroup>
            {supportedSchedules.map(schedule => (
              <Field<string> name="reportSchedule" type="checkbox" value={schedule} key={schedule}>
                {({ input }) => (
                  <CustomSelect
                    {...input}
                    customSelectType="checkbox"
                    onChange={e => {
                      e.target.checked && telemetryBusinessInsightsV2ReportBuilderChooseCadence(schedule);
                      input.onChange(e);
                    }}
                  >
                    <Typography.Body3>
                      <FormattedMessage id={reportScheduleOptions[schedule]} />
                    </Typography.Body3>
                  </CustomSelect>
                )}
              </Field>
            ))}
          </StyledCheckboxGroup>
          {insightsReportFormState.submitFailed && insightsReportFormState.errors?.reportSchedule && (
            <Alert variant="error" size="small">
              {formatMessage({ id: insightsReportFormState.errors.reportSchedule.id })}
            </Alert>
          )}
        </>
      }
    />
  );
};
